import Vue from 'vue'
import vClickOutside from 'v-click-outside'
import VueTouchEvents from 'vue2-touch-events'

Vue.use(vClickOutside)
Vue.use(VueTouchEvents)

Vue.directive('intersect', {
  bind (el, binding, vnode) {
    const intersectionObserver = new IntersectionObserver((entries => {
      if (entries[0].isIntersecting) {
        vnode.data.on['intersect-enter']()
      } else {
        vnode.data.on['intersect-leave']()
      }
    }))
    intersectionObserver.observe(el)
  }
})
